import { createSignal, createEffect } from "solid-js";

const STORAGE_KEY = "vektor.sidebar.collapsed";

function readInitial(): boolean {
  if (typeof localStorage === "undefined") return false;
  try {
    return localStorage.getItem(STORAGE_KEY) === "1";
  } catch {
    return false;
  }
}

const [collapsed, setCollapsed] = createSignal<boolean>(readInitial());

createEffect(() => {
  if (typeof localStorage === "undefined") return;
  try {
    localStorage.setItem(STORAGE_KEY, collapsed() ? "1" : "0");
  } catch {
    /* storage unavailable — ignore */
  }
});

export function useSidebarCollapse() {
  return {
    collapsed,
    toggleCollapse: () => setCollapsed((v) => !v),
    setCollapsed,
  };
}
